import { useQuery } from "react-query";
import DashboardApiClient from "api/DashboardApiClient";

export function useGetSportsmansData(sportType, sex, sportTrainingLevel, regionId, schoolId) {
    return useQuery(
        ["sportsmans", { sportType, sex, sportTrainingLevel, regionId, schoolId }],
        () =>
            DashboardApiClient.getSportsmansData(
                sportType,
                sex,
                sportTrainingLevel,
                regionId,
                schoolId,
            ),
    );
}
